/**
 *  @class
 *  @function ToggleBoxes
 */
if (!customElements.get('toggle-box')) {
  class ToggleBox extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('.toggle-box--button');
      this.contentHeight = this.querySelector('.toggle-box--content p').clientHeight;

      
      this.button.addEventListener('click', () => {
        this.toggleAttribute('open');
        if (this.hasAttribute('open')) {
            this.querySelector('.toggle-box--content').setAttribute('style', 'height:' + (this.contentHeight + 120) + 'px');
        } else {
            this.querySelector('.toggle-box--content').setAttribute('style', 'height: 0px');
        }
      });
    }
  }
  customElements.define('toggle-box', ToggleBox);
}

//Prevent Scroll
function preventDefault(e) {
  e.preventDefault();
}
// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
  window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
    get: function () { supportsPassive = true; } 
  }));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

// call this to Disable
function disableScroll() {
  window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
  window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
}

// call this to Enable
function enableScroll() {
  window.removeEventListener('DOMMouseScroll', preventDefault, false);
  window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
}
//END Prevent Scroll


let variation = 0;
let searchElements = document.querySelector('.toggle-boxes--inner.swipe-on-desktop');
searchElements.addEventListener('mouseenter', (e) => {
  disableScroll();
});
searchElements.addEventListener('mouseleave', (e) => {
   enableScroll();
});
searchElements.addEventListener('wheel', function (e) {
  if(variation < 0){
    variation = 0;
  }else if(variation > (searchElements.scrollWidth-searchElements.offsetWidth)) {
    variation = searchElements.scrollWidth-searchElements.offsetWidth;
  } else {
    variation += parseInt(e.deltaY);
  }
  searchElements.scrollLeft = (variation);
  searchElements.style.cssText = 'scroll-behavior: smooth;';
  return false;
}, true);
